/**
 * Contains all the modals that are currently rendered on the screen.
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  renderedModals: [],
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    addModal: (state, { payload }) => {
      const { callback, id } = payload;
      state.renderedModals.push({ callback, id });
    },
    removeModal: (state, { payload }) => {
      const { id } = payload;
      state.renderedModals = state.renderedModals.filter((i) => i.id !== id);
    },
    reset: () => initialState,
  },
});

export const { addModal, removeModal, reset: resetModals } = modalsSlice.actions;

export default modalsSlice.reducer;
